/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

// === Klaviyo Notify : A方式（イベント方式） ===
(function () {
  // クリックした商品情報を保持
  window.__notifyContext = null;

  // Notifyボタン押下：context保存 + openForm
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-klaviyo-open-form][data-form-id]');
    if (!btn) return;

    const formId = btn.getAttribute('data-form-id');
    if (!formId) return;

    window.__notifyContext = {
      formId,
      product_handle: btn.getAttribute('data-product-handle') || '',
      product_title: btn.getAttribute('data-product-title') || '',
      product_image: btn.getAttribute('data-product-image') || '',
      product_url: window.location.href
    };

    console.log('[Notify] context stored', window.__notifyContext);

    // ★これが無いとフォームは開きません
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });

  // フォーム送信：ログ + Notify Requested track
 window.addEventListener('klaviyoForms', function (e) {
  console.log('[Notify] klaviyoForms fired', e.detail);
  if (!e || !e.detail) return;
  if (!window.__notifyContext) return;

  console.log('[Notify] type=', e.detail.type);
  console.log('[Notify] metaData=', e.detail.metaData);
  console.log('[Notify] ctx=', window.__notifyContext);

  // submit/stepSubmit を送信扱いにする（環境差対策）
  const t = String(e.detail.type || '').toLowerCase();
  const looksLikeSubmit = (t === 'submit' || t === 'stepsubmit' || t === 'submitted' || t === 'success');
  if (!looksLikeSubmit) return;

  // ✅ 1) metaDataから拾う（入ってる環境もある）
  let email =
    e.detail.metaData?.email ||
    e.detail.metaData?.Email ||
    e.detail.metaData?.$email ||
    null;

  // ✅ 2) ダメならDOMから拾う（これが本命）
  if (!email) {
    const emailInput = document.querySelector('.klaviyo-form input[name="email"], .klaviyo-form input[type="email"]');
    email = emailInput ? emailInput.value : null;
  }

  console.log('[Notify] email=', email);

  if (!email) {
    console.warn('[Notify] email not found - skip track');
    return;
  }

  console.log('[Notify] DO TRACK now');

window._learnq = window._learnq || [];

window._learnq.push(['identify', { '$email': email }]);
// track 側にも「$email」を直接含め、さらに「setTimeout」で一瞬だけ遅らせます
setTimeout(function() {
  console.log('[Notify] DO TRACK now');
  window._learnq.push(['track', 'Notify Requested', {
    '$email': email, // ★イベント自体にアドレスを直結させる（必須）
    'product_handle': window.__notifyContext.product_handle,
    'product_title': window.__notifyContext.product_title,
    'product_url': window.__notifyContext.product_url,
    'product_image': window.__notifyContext.product_image
  }]);
  window.__notifyContext = null;
}, 500); // 0.5秒のディレイ
});

})();


